import ReputationComment from "./Comment/index.vue"
import Api from "./../../../../services/api"

export default {
  name: "ReputationData",
  props: {
    display: {
      type: Boolean,
      default: true,
    },
    reviews: {
      type: Array,
      default: [],
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    repType: {
      type: String,
      default: 'product'
    }
  },
  components: {
    ReputationComment,
  },
  mounted() {},
  data() {
    return {
      formGiveReviews: {
        title: "",
        message: "",
        star: 1,
      },
      reviewsAll: [],
      reviewsPositives: [],
      reviewsNegatives: [],
      reviewsNegatives: [],
      countReviews1Star: 0,
      countReviews2Star: 0,
      countReviews3Star: 0,
      countReviews4Star: 0,
      countReviews5Star: 0,
      averageBetween: 0,
    }
  },
  methods: {
    show() {
      this.display = true
    },
    hide() {
      this.display = false
    },
    setRating(rating) {
      if (this.isOwner) {
        const typeName = (this.repType === 'service') ? 'service' : 'product'
        alert('It is impossible to rate your own ' + typeName + '.')
        return
      }

      this.formGiveReviews.star = rating
      $("#modalGiveReviews").modal("open")
    },
    async sendReviews() {
      try {
        let isValid = await this.$validator.validateAll("formGiveReviews")
        if (!isValid) return

        this.$parent.$refs.progress.show()

        var response = await Api.createReviews(
          this.$route.params.id,
          this.formGiveReviews.title,
          this.formGiveReviews.message,
          this.formGiveReviews.star
        )

        if (response.data.message) alert(response.data.message)
        else this.reviews.push(response.data.results)
      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        $("#modalGiveReviews").modal("close")
        this.$parent.$refs.progress.hide()
      }
    },
    calculateProgress(star) {
      if (star <= 0) return 0

      return star / this.reviewsAll.length * 100
    },
  },
  watch: {
    reviews(value) {
      if (value.length > 0) {
        this.reviewsAll = value

        this.reviewsPositives = value.filter(item => item.countStar > 3)

        this.reviewsNegatives = value.filter(item => item.countStar <= 3)

        this.countReviews1Star = value.filter(
          item => item.countStar <= 1
        ).length

        this.countReviews2Star = value.filter(
          item => item.countStar <= 2 && item.countStar > 1
        ).length

        this.countReviews3Star = value.filter(
          item => item.countStar <= 3 && item.countStar > 2
        ).length

        this.countReviews4Star = value.filter(
          item => item.countStar <= 4 && item.countStar > 3
        ).length

        this.countReviews5Star = value.filter(
          item => item.countStar > 4
        ).length

        this.averageBetween =
          value.reduce((a, b) => {
            return { countStar: a.countStar + b.countStar }
          }).countStar / value.length
      }
    },
  },
  computed: {},
  mounted() {
    this.$nextTick(function() {
      $("#modalGiveReviews").modal()
      $("#modalReviews").modal({
        ready: function(modal, trigger) {
          $(".tabs").tabs()
        },
      })
    })
  },
  created() {},
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Widget/ReputationData/ReputationData.component.js